import React, { createContext, useContext, useState, useMemo } from 'react';

interface IDarkModeContext {
    isDark: boolean;
    toggle: () => void;
    setDark: (dark: boolean) => void;
}

const DarkModeContext = createContext<IDarkModeContext>({
    isDark: false,
    toggle: () => undefined,
    setDark: () => undefined,
});

export const DarkModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isDark, setIsDark] = useState(false);

    const toggle = () => setIsDark(prev => !prev);
    const setDark = (dark: boolean) => setIsDark(dark);

    const contextValue = useMemo(() => ({ isDark, toggle, setDark }), [isDark]);
    return <DarkModeContext.Provider value={contextValue}>{children}</DarkModeContext.Provider>;
};

export const useDarkMode = () => useContext(DarkModeContext);
